module.exports = __webpack_public_path__ + "static/NodeJsLocation-cb229513655d6b875df0986744b21f37.png";